import { useMemo } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import SectionDetails from '../../_Sections/SectionDetails';
import SectionGallery from '../../_Sections/SectionGallery';
import SectionDropship from '../../_Sections/SectionDropship';
import SectionPairings from '../../_Sections/SectionPairings';
import SectionBranding from '../../_Sections/SectionBranding';
import SectionSizes from '../../_Sections/SectionSizes';
import { useSelector } from 'react-redux';
import WebsiteStore from '../../../WebsiteStore';
import { styled } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import SectionPricing from '../../_Sections/SectionPricing';
import tKey from '../../../Common/Utils/tKey';
import { useAppSelector } from '../../../Common/_hooks/useAppSelector';
import ProductSEO from '../../_Sections/ProductSEO';

const PRODUCT_ID = 62;
const VIEW_PRODUCT_ID = 30;

export default function RunnerShortsPage() {
  const [t] = useTranslation('page/products/runner-shorts');
  const productData = useAppSelector(state => state.get('appData').get('products').get(String(PRODUCT_ID)));
  const locale = useAppSelector(state => state.get('userData').get('prefs').get('lang'))

  if (!productData) return null

  return <div className="centered-page product-page-v4">
    <ProductSEO
      viewProductId={VIEW_PRODUCT_ID}
      title={t('Custom all-over print Runner Shorts | Products')}
      description={t('Design and create your own custom printed Runner Shorts featuring your artwork. ✔ Print-on-demand drop shipping ✔ No minimums ✔ Made in Canada')}
    />
    <SectionDetails
      viewProductId={VIEW_PRODUCT_ID}
      color="#88dddd"
      bgStyle={{
        backgroundPosition: 'bottom right',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '47%',
      }}
      tag={t('The all-over print')}
      title={t('Runner Shorts')}
      text={t('Slay your next marathon in custom all-over print runners shorts made on-demand in Montreal, Canada. Designed with a sleek low-rider cut, foldover waistband, and body-hugging fit, they’re crafted from ultrasoft Luxeform fabric for comfort and flexibility. Vivid, fade-resistant prints bring bold energy to marathons, beach days, or workouts.')}
      createUrl={productData.get('url_slug')}
      img={require('@resources/img/pages/products/runner-shorts/banner-1-' + locale + '.png')}
      alt={t('Picture of Runner Shorts')}
      details={[
        {
          img: require('@resources/img/pages/products/runner-shorts/icon-1.svg?url'),
          alt: t('icon'),
          text: t('Body-hugging fit with low-rise waist and foldover elastic. '),
        },
        {
          img: require('@resources/img/pages/products/runner-shorts/icon-2.svg?url'),
          alt: t('icon'),
          text: t('Made from Luxeform performance fabric: combining the power of spandex with lightness and comfort'),
        },
        {
          img: require('@resources/img/pages/products/runner-shorts/icon-3.svg?url'),
          alt: t('icon'),
          text: t('Full coverage low-rider cut with side seams'),
        },
        {
          img: require('@resources/img/pages/products/runner-shorts/icon-4.svg?url'),
          alt: t('icon'),
          text: t('Vibrant, permanent prints won’t fade with use or washing'),
        },
        {
          img: require('@resources/img/pages/products/runner-shorts/icon-5.svg?url'),
          alt: t('icon'),
          text: t('Digitally printed on demand in Montreal, Canada'),
        },
      ]}
    />
    {/*<SectionGallery images={[
      require('@resources/img/pages/products/runner-shorts/gallery_0.jpg'),
      require('@resources/img/pages/products/runner-shorts/gallery_1.jpg'),
      require('@resources/img/pages/products/runner-shorts/gallery_2.jpg'),
      require('@resources/img/pages/products/runner-shorts/gallery_3.jpg'),
      require('@resources/img/pages/products/runner-shorts/gallery_4.jpg'),
    ]} />*/}

    <SectionDropship
      title={<Trans
        t={t}
        i18nKey={tKey('<yellow>Drop ship</yellow> your Runner Shorts<br/> <pink>on-demand</pink>')}
        components={{
          yellow: <span className="ty" />,
          pink: <span className="tp" />,
        }}
      />}
      text={t('Your brand and following will love Runner Shorts! At prices designed for reselling, Runner Shorts made on demand meet the needs of sellers who prefer not to stock inventory.. Sell them in your eCommerce store and decide your profit margin')}
    />

    <SectionPricing productId={PRODUCT_ID} />

    <SectionSizes
      chart="bottoms"
      productId={PRODUCT_ID}
      title={t('Runner Shorts Sizing')}
      text={t('All measurements are approximate. Since our products are made by hand, there may be variations in the finished size of our products between orders or even within an order.')}
    />

    <SectionBranding
      hasLabel
      title={t('Brand your Runner Shorts')}
      text={t('Branding enhances your products. Add custom labels, artist cards or stickers to your packages to create a cohesive message and build your brand.')}
    />

    <SectionPairings
      text={t('Pair your Runner Shorts with these great products to create your own unique styles.')}
      productSlugs={['athletic-crop-top', 'slimfit-tank-top', 'premium-unisex-tank-top']}
    />
  </div>
}